import { setSelectedPassengerTags } from '../../trip.slice';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { TagsFilter } from 'src/common/tags/TagsFilter';

interface PassengerTagColumnFilterProps {
  open: boolean;
  onClose: () => void;
}

export function PassengerTagColumnFilter({
  open,
  onClose,
}: PassengerTagColumnFilterProps) {
  const dispatch = useAppDispatch();
  const selected = useAppSelector((state) => state.trip.selectedPassengerTags);

  return (
    <TagsFilter
      open={open}
      selected={selected}
      triggerElement={<div />}
      onApply={(tags) => {
        dispatch(setSelectedPassengerTags(tags));
      }}
      onClose={onClose}
    />
  );
}
